const pagesContractorCoreInstanceEn = {
  action: {
    approveAll: 'Approve all',
    approveAllSuccess: 'Approved all successfully',
    archive: 'Archive',
    archiveSuccess: 'Archived successfully',
    cannotApproveAll:
      'Cannot approve all because there are no waiting approval tasks',
  },
  assignee: 'Assignee',
  contractorCore: 'Contractor Core',
  instanceStatus: {
    archived: 'Archived',
    completed: 'Completed',
    inProgress: 'In Progress',
  },
  notStarted:
    'This operation task is not started yet and cannot be edited. It starts when the dependent prior operation task is completed.',
  progress: {
    title: 'Task Progress',
  },
  requestedFor: 'Requested for',
  tabs: {
    data: 'Data',
    detail: 'Detail',
    operationActivity: 'Operation Activity',
  },
  task: {
    approveSuccess: 'Task approved successfully',
    editSuccess: 'Task updated successfully',
  },
};

export default pagesContractorCoreInstanceEn;
